import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/wallet', label: 'Wallet' },
  { to: '/swap', label: 'Swap' },
  { to: '/staking', label: 'Staking' },
  { to: '/invest', label: 'Invest' },
  { to: '/copy-trade', label: 'Copy Trade' },
  { to: '/nfts', label: 'NFTs' },
  { to: '/escrow', label: 'Escrow' },
  { to: '/dapps', label: 'DApps' },
  { to: '/support', label: 'Support' },
];

const linkClass = ({ isActive }) =>
  `whitespace-nowrap text-sm transition-colors duration-300 ${isActive ? 'text-white' : 'text-text-secondary hover:text-cyber-blue'}`;

const LandingNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${scrolled ? 'bg-deepspace/95 backdrop-blur-lg shadow-lg shadow-cyber-purple/10' : 'bg-transparent'}`}>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 gap-4">
          <Link to="/" className="flex items-center shrink-0">
            <img
              src="/images/logos/trust-vault-logo-light.png"
              alt="Trust Vault LLC"
              className="h-10 w-auto object-contain"
            />
          </Link>

          <div className="hidden lg:flex items-center gap-4 xl:gap-5 min-w-0 overflow-x-auto">
            {NAV_LINKS.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.to === '/'} className={linkClass}>
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/auth"
              className="shrink-0 px-5 py-2.5 bg-gradient-cyber text-white rounded-full text-sm font-semibold hover:shadow-lg hover:shadow-cyber-purple/40 transition-all duration-300"
            >
              Sign In
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-text-primary hover:text-cyber-blue transition-colors"
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-deepspace-500 backdrop-blur-lg border-t border-dark-border shadow-2xl">
          <div className="px-4 py-6 space-y-1">
            {NAV_LINKS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={linkClass}
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="block py-2">{item.label}</span>
              </NavLink>
            ))}
            <Link
              to="/auth"
              className="block w-full mt-3 px-6 py-3 bg-gradient-cyber text-white rounded-full font-semibold text-center"
              onClick={() => setMobileMenuOpen(false)}
            >
              Sign In
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default LandingNav;
